export default __webpack_public_path__ + "static/ai-marketing-1-39efd047f22b2497f60562664a1eaa89.webp";